module.exports = __webpack_public_path__ + "static/media/favebiz-login-manager.9fd35525.png";